var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-form-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.condition),expression:"condition"}],staticClass:"custom-grid-checkbox",attrs:{"id":_vm.templateArgs.id},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }